import { create } from "zustand";
import { IClient, IColetas, IDriver, IEnterprise, IEventApcap, ITickets, IUser } from "../@types/system";

export interface useStateProps {
  token: string | null;
  user: IUser;
  clients: IClient[];
  companys: IEnterprise[];
  drivers: IDriver[];
  users: IUser[];
  agenda: [];
  coletas: IColetas[];
  
  // APCAP-BR-PAINEL
  tickets: ITickets[];
  events: IEventApcap[];

  setToken: (token: string) => void;
  setUser: (user: IUser) => void;
  setUsers: (user: IUser[]) => void;
  setAgenda: (agenda: []) => void;
  setClients: (user: IClient[]) => void;
  setCompanys: (user: IEnterprise[]) => void;
  setDrivers: (drivers: IDriver[]) => void;
  setColetas: (coletas: IColetas[]) => void;

  // APCAP-BR-PAINEL
  setEvents: (events: IEventApcap[]) => void;
  setTickets: (tickets: ITickets[]) => void;

  clearLogin: () => void;
}

export const useStore = create<useStateProps>((set) => {
  return {
    token: null,
    user: {} as IUser,
    clients: [],
    companys: [],
    drivers: [],
    events: [],
    users: [],
    agenda: [],
    coletas: [],
    tickets: [],

    setToken: (token) => set({ token }),
    setUser: (user) => set({ user }),
    setUsers: (users) => set({ users }),
    setAgenda: (agenda) => set({ agenda }),
    setClients: (clients) => set({ clients }),
    setCompanys: (companys) => set({ companys }),
    setDrivers: (drivers) => set({ drivers }),
    setColetas: (coletas) => set({ coletas }),

    // APCAP-BR-PAINEL
    setEvents: (events) => set({ events }),
    setTickets: (tickets) => set({ tickets }),

    clearLogin: () => {
      sessionStorage.removeItem("@apcap:provisionalPwd");
      set({
        token: null,
        user: {} as IUser,
      });
    },
  };
});
